module.exports = __webpack_public_path__ + "assets/img/house-1.377b286e.png";